// @flow

import { startRequest, finishRequest } from "@store/utils";
import { cloneObject } from "@utils/object";

import {
  GetServiceDeskIssueTypes,
  GetServiceDeskIssueTypesSuccess,
  GetServiceDeskIssueTypesError,
  GetServiceDeskIssueFormData,
  GetServiceDeskIssueFormDataSuccess,
  GetServiceDeskIssueFormDataError,
  ResetServiceDeskIssueFormData,
  AddServiceDeskIssue,
  AddServiceDeskIssueSuccess,
  AddServiceDeskIssueError,
  AddServiceDeskIssueAttachment,
  AddServiceDeskIssueAttachmentSuccess,
  AddServiceDeskIssueAttachmentError,
  GetServiceDeskTickets,
  GetServiceDeskTicketsSuccess,
  GetServiceDeskTicketsError,
  GetServiceDeskTicketContent,
  GetServiceDeskTicketContentSuccess,
  GetServiceDeskTicketContentError,
  ResetServiceDeskTicketContent,
} from "@modules/profile/constants/actions";
import type { ServiceDeskState } from "./types";

export const initialState: ServiceDeskState = {
  requestsInProgress: 0,
  error: null,
  issueTypes: [],
  formData: null,
  ticketContent: null,
  createdTickets: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
};

const setLoading = (state: ServiceDeskState) => () => {
  return {
    ...startRequest(state),
  };
};

const setLoaded = (state: ServiceDeskState) => () => {
  return {
    ...finishRequest(state),
  };
};

const onError = (state: ServiceDeskState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};

const onGetServiceDeskIssueTypesSuccess = (state: ServiceDeskState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    issueTypes: payload,
  };
};

const onGetServiceDeskIssueFormDataSuccess = (state: ServiceDeskState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    formData: payload,
  };
};

const onResetServiceDeskIssueFormData = (state: ServiceDeskState) => ({ payload }: Object) => {
  return {
    ...state,
    formData: null,
  };
};

const onGetServiceDeskTicketsSuccess = (state: ServiceDeskState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    createdTickets: payload,
  };
};

const onGetServiceDeskTicketContentSuccess = (state: ServiceDeskState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    ticketContent: payload,
  };
};

const onResetServiceDeskTicketContent = (state: ServiceDeskState) => ({ payload }: Object) => {
  return {
    ...state,
    ticketContent: null,
  };
};

export default (state: ServiceDeskState = initialState, action: Object): ServiceDeskState => {
  const act = {
    [GetServiceDeskIssueTypes]: setLoading,
    [GetServiceDeskIssueTypesSuccess]: onGetServiceDeskIssueTypesSuccess,
    [GetServiceDeskIssueTypesError]: onError,
    [GetServiceDeskIssueFormData]: setLoading,
    [GetServiceDeskIssueFormDataSuccess]: onGetServiceDeskIssueFormDataSuccess,
    [GetServiceDeskIssueFormDataError]: onError,
    [ResetServiceDeskIssueFormData]: onResetServiceDeskIssueFormData,
    [AddServiceDeskIssue]: setLoading,
    [AddServiceDeskIssueSuccess]: setLoaded,
    [AddServiceDeskIssueError]: onError,
    [AddServiceDeskIssueAttachment]: setLoading,
    [AddServiceDeskIssueAttachmentSuccess]: setLoaded,
    [AddServiceDeskIssueAttachmentError]: onError,
    [GetServiceDeskTickets]: setLoading,
    [GetServiceDeskTicketsSuccess]: onGetServiceDeskTicketsSuccess,
    [GetServiceDeskTicketsError]: onError,
    [GetServiceDeskTicketContent]: setLoading,
    [GetServiceDeskTicketContentSuccess]: onGetServiceDeskTicketContentSuccess,
    [GetServiceDeskTicketContentError]: onError,
    [ResetServiceDeskTicketContent]: onResetServiceDeskTicketContent,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
